// components
import {
  styled,
  Typography,
  Box,
  BoxProps,
  TypographyProps
} from '@mui/material';

export const StyledNameSectionTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'lineClamp' && prop !== 'isAbsent'
})<TypographyProps & { lineClamp?: number; isAbsent?: boolean }>(
  ({ lineClamp, isAbsent }) => ({
    overflow: 'hidden',
    display: '-webkit-box',
    lineHeight: 'normal',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lineClamp || 'initial',
    textOverflow: 'ellipsis',
    fontSize: '14px',
    textDecoration: isAbsent ? 'line-through' : 'none'
  })
);

export const StyledNameSectionBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSideDrawer'
})<BoxProps & { isSideDrawer?: boolean }>(({ theme, isSideDrawer }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: isSideDrawer ? 0 : theme.spacing(1, 0, 1, 1),
  marginRight: theme.spacing(6)
}));
